import { createSlice } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'
import { persistReducer } from 'redux-persist'

const initialState = {
    locked: false,
    showAlert: false,
    alertType: '',
    mode: '',
    currentApplicationID: '',
    error: false,
    errorPhrase: "",
    info: false,
    infoPhrase: ""
}

const appViewerSlice = createSlice({
    name: "appViewer",
    initialState,
    reducers: {
        toggleLock: (state) => {
            state.locked = !state.locked
        },
        setLock: (state,action) => {
            state.locked = action.payload.locked
        },
        showAlert: (state,action) => {
            state.showAlert = true
            state.alertType = action.payload.alertType
        },
        hideAlert: (state) => {
            state.showAlert = false
            state.alertType = ''
        },
        setMode: (state,action) => {
            state.mode = action.payload.mode
        },
        setCurrentApplicationID: (state,action) => {
            state.currentApplicationID = action.payload.currentApplicationID
        },
        appViewerError: (state,action) => {
            state.error = true
            state.errorPhrase = action.payload.errorPhrase
        },
        appViewerInfo: (state,action) => {
            state.info = true
            state.infoPhrase = action.payload.infoPhrase
        },
        resetDropDownAlert: (state) => {
            state.error = initialState.error
            state.errorPhrase = initialState.errorPhrase
            state.info = initialState.info
            state.infoPhrase = initialState.infoPhrase
        },
        reset: state => initialState,
    },
})

const persistConfig = {
    key: 'appViewer',
    storage: storage,
    whitelist: ['mode','locked','currentApplicationID','locked']
}

export const { toggleLock, setLock, showAlert, hideAlert, setMode, setCurrentApplicationID, appViewerError, appViewerInfo, resetDropDownAlert, reset } = appViewerSlice.actions
export default persistReducer(persistConfig, appViewerSlice.reducer)